import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import * as styles from "./InvoiceFooterStyles";

const RulesSection: React.FC = () => (
  <TableRow style={styles.rowBorderStyle} data-testid="rules-section">
    <TableCell sx={styles.rulesLeftCell} data-testid="rules-left-column">
      <div style={{ fontSize: "10px", lineHeight: "18px" }}>
        - Kegs should be stored and consumed as instructed by the company.{" "}
        <br />
        - The kegs are the property of ARRKP Hospitality Pvt. Ltd. <br />- Empty
        Kegs should be returned to the Brewery in good condition.
      </div>
    </TableCell>
    <TableCell sx={styles.rulesRightCell} data-testid="rules-right-column">
      <div style={{ fontSize: "10px", lineHeight: "16px" }}>
        - Kegs once sold cannot be taken back or exchanged. <br />
        - Kindly check the kegs on delivery. <br />
        - Do not accept the kegs if the seal has been tampered with. <br />-
        Kindly process payments as per terms discussed for uninterrupted supply.
      </div>
    </TableCell>
  </TableRow>
);

const SignaturesSection: React.FC = () => (
  <TableRow style={styles.rowBorderStyle}>
    <TableCell sx={styles.signaturesLeftCell}>
      Receivers Seal & Signature
    </TableCell>
    <TableCell sx={styles.signaturesRightCell}>
      For ARRKP Hospitality Pvt Limited
    </TableCell>
  </TableRow>
);

const EmptyRow: React.FC = () => (
  <TableRow>
    <TableCell sx={styles.emptyRowCell} />
    <TableCell sx={styles.emptyRowCellRight}>
      {/* Signature Image with Proper Alignment */}
      <img
        src="https://zap-erp-images.s3.ap-south-1.amazonaws.com/signn.png"
        alt="Signature"
        style={styles.signResize}
      />
    </TableCell>
  </TableRow>
);

interface InvoiceFooterProps {
  showSignaturesOnly?: boolean;
}

const InvoiceFooter: React.FC<InvoiceFooterProps> = ({
  showSignaturesOnly = false,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {!showSignaturesOnly && <RulesSection />}{" "}
          {/* Conditionally render Rules Section */}
          <SignaturesSection /> {/* Always render the Signatures Section */}
          <EmptyRow />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceFooter;
